type NetworkingMapZoomControlsProps = {
  canZoomIn: boolean;
  canZoomOut: boolean;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
};

function ZoomIconPlus() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="currentColor"
        d="M11.25 12.75H5.5v-1.5h5.75V5.5h1.5v5.75H18.5v1.5h-5.75V18.5h-1.5v-5.75Z"
      />
    </svg>
  );
}

function ZoomIconMinus() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path fill="currentColor" d="M5.5 11.25h13v1.5h-13v-1.5Z" />
    </svg>
  );
}

function ZoomIconReset() {
  return (
    <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
      <path
        fill="currentColor"
        d="M7 3H3v4h1.5V4.5H7V3Zm14 4V3h-4v1.5h2.5V7H21ZM7 21v-1.5H4.5V17H3v4h4Zm14-4h-1.5v2.5H17V21h4v-4ZM12 8.5A3.5 3.5 0 1 0 12 15.5 3.5 3.5 0 0 0 12 8.5Zm0 1.5a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
      />
    </svg>
  );
}

const buttonClass =
  "flex h-10 w-10 items-center justify-center bg-white text-[#3C4043] transition-colors hover:bg-[#F1F3F4] disabled:cursor-default disabled:text-[#BDC1C6]";

export default function NetworkingMapZoomControls({
  canZoomIn,
  canZoomOut,
  onZoomIn,
  onZoomOut,
  onReset,
}: NetworkingMapZoomControlsProps) {
  return (
    <div
      className="absolute bottom-3 right-3 z-20 flex flex-col overflow-hidden rounded-[2px] border border-[#DADCE0] bg-white shadow-[0_1px_4px_rgba(0,0,0,0.3)]"
      onMouseDown={(event) => event.stopPropagation()}
      onPointerDown={(event) => event.stopPropagation()}
    >
      <button
        type="button"
        className={buttonClass}
        aria-label="Zoom in"
        title="Zoom in"
        disabled={!canZoomIn}
        onClick={onZoomIn}
      >
        <ZoomIconPlus />
      </button>
      <div className="h-px bg-[#DADCE0]" />
      <button
        type="button"
        className={buttonClass}
        aria-label="Zoom out"
        title="Zoom out"
        disabled={!canZoomOut}
        onClick={onZoomOut}
      >
        <ZoomIconMinus />
      </button>
      <div className="h-px bg-[#DADCE0]" />
      <button
        type="button"
        className={buttonClass}
        aria-label="Reset zoom"
        title="Reset zoom"
        onClick={onReset}
      >
        <ZoomIconReset />
      </button>
    </div>
  );
}
